<div>
    <div class="row jcc">

        <div class="col-md-10 px-0 mb-3">
            <button class="btn btn-danger btn waves-effect btn-rounded pull-left m-r-5" (click)="back()">Atrás</button>
            <button style="margin-left: auto;" class="btn btn-success waves-effect btn btn-rounded m-r-5 f-right" (click)="generatePdf()"> Exportar a PDF</button>
            <button class="btn btn-primary waves-effect btn btn-rounded m-r-5 f-right" (click)="share()" > Compartir reporte</button>
        </div>
        <div class="col-12 col-md-10">


            <h3 class="mt-3 mb-5" *ngIf="user">Reporte historíco de {{user.name}} para el test {{testName}}</h3>
            <canvas id="pfChart" baseChart
                [datasets]="barChartData"
                [labels]="barChartLabels"
                [options]="barChartOptions"
                [legend]="true"
                [chartType]="'line'">
            </canvas>
        </div>
    </div>
</div>